/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { IsolatedReportService } from '../services/isolatedReport.service';
import { LoggerService } from '../../shared/services/logger.service';
import { Component, Input } from '@angular/core';
import { ReportDefinition } from '../state/report.model';
import { ReportDataSource } from './datasource/report.datasource';

// noinspection AngularMissingOrInvalidDeclarationInModule
@Component({
    selector: 'dash-gis-report-content-base',
    template: '',
})
export class ReportContentBaseComponent {
    @Input() public definition: ReportDefinition;
    @Input() public keys: any[];
    @Input() public dataSource: ReportDataSource;

    constructor(protected logger: LoggerService, protected isolatedReportService: IsolatedReportService) {}

    getFieldDefinition(name: string) {
        const fieldIndex = this.definition.fields.findIndex((f) => f.name === name);
        return fieldIndex !== -1 ? this.definition.fields[fieldIndex] : false;
    }

    get id() {
        return this.isolatedReportService.id;
    }
}
